<script setup>
import { ref } from 'vue';

const props = defineProps({
    titulo: {
        type: String,
        required: true
    },
    descricao: {
        type: String,
        default: ''
    },
    labelBotaoFechar: {
        type: String,
        default: 'Fechar'
    },
    largura: {
        type: String,
        default: '90vw'
    },
    maxLargura: {
        type: String,
        default: '1200px'
    },
    loading: {
        type: Boolean,
        default: false
    }
});

const emit = defineEmits(['fechar']);

const visible = ref(true);

const handleFechar = () => {
    visible.value = false;
    emit('fechar');
};

const handleAfterHide = () => {
    visible.value = false;
    emit('fechar');
};
</script>

<template>
    <Dialog :visible="visible" :closable="false" appendTo="body" modal :draggable="false" :resizable="false"
        :dismissableMask="true" :style="{ width: largura, maxWidth: maxLargura }" @after-hide="handleAfterHide" :pt="{
            header: { class: 'border-bottom-1 surface-border px-4 lg:px-5' },
            footer: { class: 'border-top-1 surface-border px-4 lg:px-5 pt-4' },
            content: { class: 'px-4 lg:px-5 py-5 surface-ground' },
        }">
        <template #header>
            <div class="flex flex-column gap-2">
                <h2 class="text-xl font-bold m-0">{{ titulo }}</h2>
                <p class="text-sm text-600 m-0" v-if="descricao">
                    {{ descricao }}
                </p>
                <slot name="header"></slot>
            </div>
        </template>

        <Carregador :carregando="loading" class="flex justify-content-center align-items-center" style="min-height: 200px">
            <div class="grid formgrid p-fluid">
                <slot></slot>
            </div>
        </Carregador>

        <template #footer>
            <div class="flex justify-content-end gap-2">
                <Button :label="labelBotaoFechar" severity="secondary" @click="handleFechar"
                    class="p-button-text text-sm" />
            </div>
        </template>
    </Dialog>
</template>
